import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <span class="wc-avatar rounded-circle shadow-sm bg-white text-primary d-inline-block d-flex justify-content-center align-items-center"></span>
`;

export class WCAvatar extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcAvatar = clone.content.querySelector('.wc-avatar');
    let dataNoBg = this.hasAttribute('data-no-bg');
    let dataNoShadow = this.hasAttribute('data-no-shadow');
    let data1x = this.hasAttribute('data-1x'); // não faz sentido mas vamos deixar aqui
    let data2x = this.hasAttribute('data-2x');
    let data3x = this.hasAttribute('data-3x');
    let scale = data3x ? 'scale-3x' : data2x ? 'scale-2x' : 'scale-1x';
    wcAvatar.classList.add(scale);
    if (dataNoBg) wcAvatar.classList.remove('bg-white');
    if (dataNoShadow) wcAvatar.classList.remove('shadow-sm');
    if (this.hasAttribute('data-class-bg') && !dataNoBg) {
      wcAvatar.classList.remove('bg-white');
      wcAvatar.classList.add(this.getAttribute('data-class-bg'));
    }
    if (this.hasAttribute('data-class-text')) {
      wcAvatar.classList.remove('text-primary');
      wcAvatar.classList.add(this.getAttribute('data-class-text'));
    }
    contentNodes.forEach(node => {
      wcAvatar.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcAvatar);
  }

}